class NavigationMoreLess {
    constructor() {
        // 1. Find the button first.
        this.button = document.querySelector('[data-more-less-button]');
        if (!this.button) {
            return;
        }

        // 2. The navigation list is the button's direct previous sibling.
        this.navList = this.button.previousElementSibling;
        if (!this.navList || this.navList.tagName !== 'UL') {
            return;
        }

        this.navItems = this.navList.querySelectorAll('.navigation-item');
        if (this.navItems.length === 0) {
            return;
        }

        this.buttonText = this.button.querySelector('[data-text]');
        this.buttonIcon = this.button.querySelector('.navigation__links-icon');
        this.isExpanded = false;
        this.moreText = this.button.dataset.moreText;
        this.lessText = this.button.dataset.lessText;

        this.desktopMediaQuery = window.matchMedia('(min-width: 958px)');
        this.onButtonClick = this.toggle.bind(this);
        this.onResize = () => this.update();

        this.button.addEventListener('click', this.onButtonClick);
        this.desktopMediaQuery.addEventListener('change', this.handleMediaQueryChange.bind(this));

        this.handleMediaQueryChange(this.desktopMediaQuery);
    }

    handleMediaQueryChange(e) {
        if (e.matches) {
            this.init();
        } else {
            this.destroy();
        }
    }

    init() {
        window.addEventListener('resize', this.onResize);
        // setTimeout(() => this.update(), 50);
        this.update();
    }

    destroy() {
        window.removeEventListener('resize', this.onResize);
        this.navItems.forEach(item => item.classList.remove('is-hidden'));
        // The navList now holds the state classes.
        this.navList.classList.remove('is-collapsed', 'is-expanded');
        this.isExpanded = false;
    }

    update() {
        if (!this.desktopMediaQuery.matches || this.isExpanded) return;

        // Reset state on the nav list for accurate measurement.
        this.navList.classList.remove('is-collapsed');
        this.navItems.forEach(item => item.classList.remove('is-hidden'));

        if (this.navItems.length === 0) return;

        const firstItemTop = this.navItems[0].offsetTop;
        let wrapIndex = -1;

        this.navItems.forEach((item, index) => {
            if (item.offsetTop > firstItemTop) {
                if (wrapIndex === -1) {
                    wrapIndex = index;
                }
            }
        });

        // If a wrap is detected, add the class to the nav list itself.
        if (wrapIndex !== -1) {
            this.navList.classList.add('is-collapsed');
            for (let i = wrapIndex; i < this.navItems.length; i++) {
                this.navItems[i].classList.add('is-hidden');
            }
        }
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
        this.button.setAttribute('aria-expanded', this.isExpanded);
        // Toggle the class on the nav list.
        this.navList.classList.toggle('is-expanded', this.isExpanded);

        const firstItemTop = this.navItems[0].offsetTop;
        let wrapIndex = -1;

        this.navItems.forEach((item, index) => {
            if (item.offsetTop > firstItemTop) {
                if (wrapIndex === -1) {
                    wrapIndex = index;
                }
            }
        });

        if (this.isExpanded) {
            this.buttonText.textContent = this.lessText;
            this.buttonIcon.style.transform = 'rotate(180deg)';
            this.buttonIcon.style.marginTop = '3px';
            this.navItems.forEach(item => item.classList.remove('is-hidden'));
        } else {
            this.buttonText.textContent = this.moreText;
            this.buttonIcon.style.transform = '';
            this.buttonIcon.style.marginTop = '';
            if (wrapIndex !== -1) {
                for (let i = wrapIndex; i < this.navItems.length; i++) {
                    this.navItems[i].classList.add('is-hidden');
                }
            }
        }
    }
}

if (typeof NavigationMoreLess !== 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
        new NavigationMoreLess();
    });
}